import {
  createRootRoute,
  createRoute,
  createRouter,
  Outlet,
  RouterProvider,
} from '@tanstack/react-router';
import { IndexRoute } from './routes/index.tsx';
import { EditRoute } from './routes/edit.tsx';

const rootRoute = createRootRoute({
  component: () => <Outlet />,
});

const indexRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/',
  component: IndexRoute,
});

const editRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/edit',
  component: EditRoute,
});

const editJobRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/edit/$jobId',
  component: EditRoute,
});

const routeTree = rootRoute.addChildren([indexRoute, editRoute, editJobRoute]);

const router = createRouter({ routeTree });

declare module '@tanstack/react-router' {
  interface Register {
    router: typeof router;
  }
}

export function App() {
  return <RouterProvider router={router} />;
}
